import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-products",
  "use": "icon-soc-l1-products-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-products\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M256 192l256-64 256 64v128L512 384 256 320V192zm0 192l256 64 256-64v384H256V384zm64 96v224h384V480L512 544 320 480z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-products.svg
// module id = 7tbB
// module chunks = 546